import BmcCardModel from './likelyContentTypes/BmcCard.model';
import NodeCardModel from './likelyContentTypes/NodeCard.model';
import RegionCardModel from './likelyContentTypes/RegionCard.model';

export default class LikelyContent {
  constructor({ cards_regionales: regionCards, node_around: nodeCards, bmc: bmcCards } = {}) {
    this.regionCards = regionCards?.map((card) => new RegionCardModel(card));
    this.nodeCards = Object.values(nodeCards || {})?.map((card) => new NodeCardModel(card));
    this.bmcCards = bmcCards?.map((card) => new BmcCardModel(card));
    this.total = (this.bmcCards?.length ?? 0) + (this.nodeCards?.length ?? 0) + (this.regionCards?.length ?? 0);
  }

  getNodeCards() {
    return this.nodeCards || [];
  }

  getRegionCards() {
    return this.regionCards || [];
  }

  getBmcCards() {
    return this.bmcCards || [];
  }

  getTotal() {
    return this.total;
  }
}
